module.exports = __webpack_public_path__ + "4_logo_jewellry_rovcanin_rvcnn_price_tag_handcraft.jpg?4893fbe8f8eba50a3efc58953b3fe538";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/4_logo_jewellry_rovcanin_rvcnn_price_tag_handcraft.jpg
// module id = 90
// module chunks = 0